import { ENDPOINTS } from "config/endpoints";
import { useMutation } from "react-query";
import Error from "types/error";
import client from "utils/clients/client";
import { Request } from "types/request";
import { Response } from "types/response";

export default function useSyncDocuments() {
  const syncDocuments = () => {
    const request: Request = {
      url: ENDPOINTS.documents.sync,
      config: {
        method: "post",
      },
    };

    return client(request);
  };

  const { isSuccess, isError, isLoading, mutate, ...rest } = useMutation<
    Response<null>,
    Error,
    void
  >(syncDocuments, {});

  return { isSuccess, isError, isLoading, mutate, ...rest };
}
